import { render, staticRenderFns } from "./TgsList.vue?vue&type=template&id=2c771089&"
import script from "./TgsList.vue?vue&type=script&lang=js&"
export * from "./TgsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports